import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { Text } from '@mantine/core';
import { AutoSaveStatus, statusConfig } from './autoSaveStatusConfig';
import { AutoSaveContainer, SpinningIcon } from './styled';
import { useAutoSaveStatus } from './useAutoSaveStatus';

const Indicator = ({ status }: { status: AutoSaveStatus }) => (
	<AutoSaveContainer data-testid={TEST_ELEMENT_IDS.AUTO_SAVER_INDICATOR}>
		<SpinningIcon
			variant="group"
			color={statusConfig[status].color}
			fillStroke={true}
			$isSpinning={status === AutoSaveStatus.SAVING}
		/>
		<Text size="B6Medium" c="gray.9" style={{ whiteSpace: 'nowrap' }}>
			{statusConfig[status].text}
		</Text>
	</AutoSaveContainer>
);

export const AutoSaveIndicator = () => {
	const status = useAutoSaveStatus();
	if (!status) {
		return null;
	}
	return <Indicator status={status} />;
};
